import AcademicCalendar from './2026-08-fall/calendar.png'
import FinalExamTimes from './2026-08-fall/final-exam-times.png'

export const renderCalendar = () => { return ( renderImage(AcademicCalendar) ) }
export const renderFinalExamTimes = () => { return ( renderImage(FinalExamTimes) ) }

const renderImage = (image) => {
	return ( <div 
		style={{display: "flex", justifyContent: "center", alignItems: "center"}}><img src={image} alt='' width='1024'/>
	</div> )
}